import { Component, Input, OnChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Html5Entities } from 'html-entities/lib/html5-entities';
import { Hotel } from '../../../../../assets/models/iter.model';
import { LocalizedCurrencyPipe } from '../../../../pipe/localized-currency.pipe';
import { getServiceNotes } from '../../common/service-notes';

/**ToDo Documentazione */
@Component({
  selector: 'app-alternatives',
  styleUrls: ['./alternatives.component.scss'],
  templateUrl: './alternatives.component.html'
})
export class AlternativesComponent implements OnChanges {
  @Input() public day: any;
  @Input() public amountaftertax: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  state: any = sessionStorage.getItem('state');
  public modal!: NgbModalRef;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  constructor(private readonly modalService: NgbModal, private localizedCurrencyPipe: LocalizedCurrencyPipe) {
  }

  ngOnChanges(): void {
    console.log(this.day);
    console.log(this.amountaftertax);
  }

  public getHotelImage(hotel: Hotel): string {
    return hotel.image ||  'assets/custom/' + sessionStorage.getItem('version') + '/images/logo_tour_operator.png';
  }

  public getTest(text: string): string {
    return Html5Entities.decode(text);
  }

  calculateDiff(roomsArray: any[]): string {
    const totalAlternativePrice = roomsArray.reduce((total, room) => {
      return total + (room.amountaftertax || 0);
    }, 0);
    
    // Totale delle camere di base
    const totalBasePrice = this.amountaftertax.reduce((total: number, room: any) => {
      return total + (room.amountaftertax || 0);
    }, 0);
    
    // Differenza
    const totalDifference = totalAlternativePrice - totalBasePrice;
    
    let format = this.localizedCurrencyPipe.transform(Math.abs(totalDifference), 'EUR', 'symbol');
    let formatZero = this.localizedCurrencyPipe.transform(0, 'EUR', 'symbol');

    if (totalDifference > 0) {
      return `<span class="plus-diff">+ ${format}</span>`;
    } else if (totalDifference < 0) {
      return `<span class="neg-diff">- ${format}</span>`;
    } else {
      return `<span class="no-diff">${formatZero}</span>`;
    }
  }

  handleImgError(ev: any){
    const source = ev.target as HTMLImageElement;
    const fallback = `assets/custom/${sessionStorage.getItem('version')}/images/logo_tour_operator.png`;
    source.src = this.noImageUrl || fallback;
  }

  public openModal(historyFeeModal: any){
    this.modal = this.modalService.open(historyFeeModal);
  } 
}
